'use strict';

Object.defineProperty(exports, "__esModule", {
      value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var CentralHeating = function (_React$Component) {
      _inherits(CentralHeating, _React$Component);

      function CentralHeating() {
            _classCallCheck(this, CentralHeating);

            return _possibleConstructorReturn(this, (CentralHeating.__proto__ || Object.getPrototypeOf(CentralHeating)).apply(this, arguments));
      }

      _createClass(CentralHeating, [{
            key: 'render',
            value: function render() {
                  return _react2.default.createElement(
                        Svg,
                        { width: '26', height: '32', viewBox: '0 0 26 32' },
                        _react2.default.createElement(Path, { fill: this.props.fill,
                              d: 'M24.958 24.433h-24.322c-0.351 0-0.636-0.286-0.636-0.636v-15.594c0-0.351 0.285-0.636 0.636-0.636h24.322c0.351 0 0.636 0.285 0.636 0.636v15.594c0 0.35-0.285 0.636-0.636 0.636zM14.375 23.76h10.546v-15.52h-10.546v15.52zM0.673 23.76h13.028v-15.52h-13.028v15.52z' }),
                        _react2.default.createElement(Path, { fill: this.props.fill,
                              d: 'M11.799 15.583h-9.448c-0.224 0-0.406-0.182-0.406-0.406v-4.339c0-0.224 0.182-0.406 0.406-0.406h9.448c0.223 0 0.406 0.182 0.406 0.406v4.339c0 0.224-0.182 0.406-0.406 0.406zM2.394 15.135h9.362v-4.254h-9.362v4.254z' }),
                        _react2.default.createElement(Path, { fill: this.props.fill,
                              d: 'M3.8 17.984c0 0.496-0.402 0.898-0.898 0.898s-0.898-0.402-0.898-0.898c0-0.496 0.402-0.898 0.898-0.898s0.898 0.402 0.898 0.898z' }),
                        _react2.default.createElement(Path, { fill: this.props.fill,
                              d: 'M2.903 21.2c-0.509 0-0.922-0.414-0.922-0.922s0.414-0.922 0.922-0.922c0.509 0 0.922 0.414 0.922 0.922s-0.414 0.922-0.922 0.922zM2.903 19.804c-0.261 0-0.474 0.212-0.474 0.474s0.213 0.474 0.474 0.474 0.474-0.212 0.474-0.474c0-0.261-0.213-0.474-0.474-0.474z' }),
                        _react2.default.createElement(Path, { fill: this.props.fill,
                              d: 'M20.148 17.867v-4.983c0-0.316-0.256-0.571-0.571-0.571s-0.572 0.256-0.572 0.571v4.983c-0.833 0.247-1.441 1.017-1.441 1.93 0 1.111 0.901 2.012 2.012 2.012s2.012-0.901 2.012-2.012c0-0.913-0.608-1.683-1.441-1.93z' }),
                        _react2.default.createElement(Path, { fill: this.props.fill,
                              d: 'M21.183 17.142v-6.436c0-0.886-0.72-1.606-1.606-1.606s-1.606 0.72-1.606 1.606v6.436c-0.928 0.561-1.497 1.561-1.497 2.655 0 1.711 1.392 3.103 3.103 3.103s3.103-1.392 3.103-3.103c0-1.094-0.569-2.093-1.497-2.655zM19.577 22.246c-1.351 0-2.45-1.099-2.45-2.449 0-0.917 0.506-1.75 1.321-2.174l0.176-0.091v-6.825c0-0.525 0.427-0.953 0.953-0.953s0.953 0.428 0.953 0.953v0.122h-0.313c-0.090 0-0.163 0.073-0.163 0.163s0.073 0.164 0.163 0.164h0.313v0.184h-0.313c-0.090 0-0.163 0.073-0.163 0.163s0.073 0.164 0.163 0.164h0.313v0.184h-0.313c-0.090 0-0.163 0.073-0.163 0.164s0.073 0.163 0.163 0.163h0.313v5.356l0.176 0.091c0.815 0.424 1.321 1.257 1.321 2.174 0 1.35-1.099 2.449-2.449 2.449z' })
                  );
            }
      }]);

      return CentralHeating;
}(_react2.default.Component);

CentralHeating.propTypes = {
      fill: _react2.default.PropTypes.string
};

exports.default = CentralHeating;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/central-heating.js
// module id = 1087
// module chunks = 0